import FirebaseTools from './FirebaseTools';
import FirebaseCollection from './FirebaseCollection';
import { AuthActions, AuthMutations } from '../stores/auth.store';
import store from '../stores';

class FirebaseAuth {
  constructor() {
    store.commit(AuthMutations.authStartQuery);
    this.firebase = FirebaseTools.firebase;
    this.init();
  }

  authenticate(email, password) {
    if (store.state.isAuthenticated) return;
    store.dispatch(AuthActions.startLogin);
    return this.firebase.auth().signInWithEmailAndPassword(email, password)
      .then((user) => {
        store.dispatch(AuthActions.endLoginSuccess, user);
        return FirebaseCollection.getCoins();
      })
      .catch(async (e) => {
        store.dispatch(AuthActions.endLoginError);
        FirebaseCollection.clean();
        throw e;
      });
  }

  logout() {
    if (!store.state.auth.isAuthenticated) return;
    store.dispatch(AuthActions.startLogout);
    return this.firebase.auth().signOut()
      .then(() => {
        store.dispatch(AuthActions.endLogoutSuccess);
        FirebaseCollection.clean();
      })
      .catch((e) => {
        store.dispatch(AuthActions.endLogoutError);
        FirebaseCollection.clean();
        throw e;
      });
  }
  init() {
    this.firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        store.dispatch(AuthActions.endLoginSuccessSilently, user);
        return FirebaseCollection.getCoins();
      } else {
        store.dispatch(AuthActions.endLogoutSuccess);
        FirebaseCollection.clean();
      }
    });
  }
}

export default new FirebaseAuth();
